import { observer } from 'mobx-react-lite';

import { NotFound } from '@features/not-found';

export const EntryPage = observer(function EntryPage() {
  return <NotFound />;
});
